import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExp } from 'src/app/core/config/regex';
import { Appraisal, AppraisalQuarter } from 'src/app/shared/models/appraisal';
import { Message } from 'src/app/shared/models/domain';
import { ApparaisalService } from 'src/app/shared/services/apparaisal.service';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
  selector: 'app-appraisal-cycle-crud',
  templateUrl: './appraisal-cycle-crud.component.html',
  styleUrls: ['./appraisal-cycle-crud.component.scss']
})
export class AppraisalCycleCrudComponent implements OnInit {
  @Input() appraisal: Appraisal;
  @Input() appraisals: Appraisal[] = [];
  public appraisalForm: FormGroup;
  public years: number[] = [];
  public selectedYear: number;
  public quarters: AppraisalQuarter[];
  public submitted: boolean = false;
  private modified: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private commonService: CommonService,
    private appraisalService: ApparaisalService
  ) { }

  ngOnInit(): void {
    this.years = this.commonService.generateYears(5);
    this.selectedYear = new Date().getFullYear();
    this.appraisalService.getAppraisalQuarters(false).subscribe((quater: AppraisalQuarter[]) => (this.quarters = quater));
    this.setAppraisalForm(this.appraisal);
  }

  public setAppraisalForm(appraisal?: Appraisal) {
    if (!appraisal)
      appraisal = {
        id: null,
        label: null,
        status: 'HR_CREATED',
        year: null,
        endYear: null,
        employeeSubDay: null,
        loneSubDay: null,
        ltwoApplicable: false,
        active: true,
        companyId: null,
        companyName: null,
        startId: null,
        startName: null,
        endId: null,
        endName: null,
      } as Appraisal;
    this.appraisalForm = this.fb.group({
      id: this.fb.control(appraisal.id || null),
      label: this.fb.control(appraisal.label, [Validators.required, Validators.pattern(RegExp.label)]),
      status: this.fb.control(appraisal.status || 'HR_CREATED'),
      year: this.fb.control(appraisal.year, [Validators.required]),
      endYear: this.fb.control(appraisal.endYear, [Validators.required]),
      employeeSubDay: this.fb.control(appraisal.employeeSubDay, [Validators.required, Validators.pattern(RegExp.number)]),
      loneSubDay: this.fb.control(appraisal.loneSubDay, [Validators.required, Validators.pattern(RegExp.number)]),
      ltwoApplicable: this.fb.control(appraisal.ltwoApplicable, []),
      active: this.fb.control(appraisal?.active || true, []),
      companyId: this.fb.control(appraisal.companyId, []),
      companyName: this.fb.control(appraisal.companyName, []),
      startId: this.fb.control(appraisal.startId, [Validators.required]),
      startName: this.fb.control(appraisal.startName, []),
      endId: this.fb.control(appraisal.endId, [Validators.required]),
      endName: this.fb.control(appraisal.endName, []),

    });
    this.appraisalForm.valueChanges.subscribe(value => this.modified = true);
  }

  get a() {
    return this.appraisalForm.controls;
  }

  public saveAppraisal(inProgress?: any) {
    this.submitted = true;
    if (this.appraisalForm.valid) {
      const appraisal: Appraisal = this.appraisalForm.value;
      if (this.appraisals.some(c => c.label.toLowerCase() === appraisal.label.toLowerCase())) {
        this.commonService.setToastr(400, `Appraisal ${appraisal.label} already exists!`);
        return;
      }
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Appraisal ${appraisal.label} has been updated successfully!`);
        return;
      }
      inProgress.value = true;
      if (appraisal.id) {
        this.appraisalService.updateAppraisal(appraisal.id, appraisal).subscribe({
          next: (response: Message) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Appraisal ${appraisal.label} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.appraisalService.createAppraisal(appraisal).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(true);
              this.commonService.setToastr(200, `Appraisal ${appraisal.label} has been created successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }
}
